import Print from './printarea.js';
/**
 * @file 打印
 * 指令`v-print`,默认打印整个窗口
 * 传入参数`v-print="'#id'"` , 参数为需要打印局部的盒子标识.
 */
/**
 * 添加事件监听器到指定的DOM元素
 *
 * @param element DOM元素，需要添加事件监听器的元素
 * @param type 字符串，需要监听的事件类型
 * @param callback 函数，事件触发时执行的回调函数
 * @returns 无返回值
 */
const addEvent = (element, type, callback) => {
  // 简单的参数检查
  // 如果 element、type 或 callback 中有任何一个不存在，则直接返回
  // 简单的参数检查
  if (!element || !type || !callback) return;

  // 直接使用addEventListener方法添加事件监听器，因为现代浏览器都已支持此方法
  // 直接使用addEventListener，因为现代浏览器都已支持
  element.addEventListener(type, callback, false);
};
export default {
  directiveName: 'print',
  mounted (el, binding, vnode) {
    let vue = binding.instance;
    let id = '';

    addEvent(el, 'click', () => {
      if (typeof binding.value === 'string') {
        // 全局打印
        id = binding.value;
      } else if (typeof binding.value === 'object' && !!binding.value.id) {
        // 局部打印
        id = binding.value.id;
        let ids = id.replace(new RegExp("#", "g"), '');
        let elsdom = document.getElementById(ids);
        if (!elsdom) console.log("id in Error"), id = '';

      } else {
        window.print();
        return
      }
      localPrint();
    })
    const localPrint = () => {
      new Print({
        ids: id, // * 局部打印必传入id
        vue,
        url: binding.value.url, // 打印指定的网址，这里不能跟id共存 如果共存id的优先级会比较高
        standard: '', // 文档类型，默认是html5，可选 html5，loose，strict
        extraHead: binding.value.extraHead, // 附加在head标签上的额外标签,使用逗号分隔
        extraCss: binding.value.extraCss, // 额外的css连接，多个逗号分开
        zIndex: binding.value.zIndex || 20002, // 预览窗口的z-index
        previewTitle: binding.value.previewTitle || '打印预览', // 打印预览的标题
        previewPrintBtnLabel: binding.value.previewPrintBtnLabel || '打印', // 打印预览的标题
        popTitle: binding.value.popTitle, // title的标题
        preview: binding.value.preview || false, // 是否启动预览模式
        asyncUrl: binding.value.asyncUrl,
        // ------------新添加的这一行-----------------
        beforeEntryIframe(){
          binding.value.beforeEntryIframe && binding.value.beforeEntryIframe(vue)
        },
        // ----------------------------------------
        previewBeforeOpenCallback () { // 预览窗口打开之前的callback
          binding.value.previewBeforeOpenCallback && binding.value.previewBeforeOpenCallback(vue)
        },
        previewOpenCallback () { // 预览窗口打开之后的callback
          binding.value.previewOpenCallback && binding.value.previewOpenCallback(vue)
        },
        openCallback () { // 调用打印之后的回调事件
          binding.value.openCallback && binding.value.openCallback(vue)
        },
        closeCallback () {
          binding.value.closeCallback && binding.value.closeCallback(vue)
        },
        beforeOpenCallback () {
          binding.value.beforeOpenCallback && binding.value.beforeOpenCallback(vue)
        }
      });

    };
  }

};